module.exports = __webpack_public_path__ + "img/client (7).e0ade70e.jpg";